import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  NEWSLETTER_GET,
  NEWSLETTER_DETAILS_GET,
  NEWSLETTER_DETAILS_RESET,
  NEWSLETTER_SEND,
  NEWSLETTER_BASE_TEMPLATE_GET,
} from '../actions/newsletter';

const initialState = {
  sentCounter: 0,
  list: [],
  details: {},
  pager: {},
  baseTemplate: null,
};

const newsletterReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case NEWSLETTER_GET._SUCCESS: {
        const { data = [], pager } = action;
        draft.list = [...data];
        draft.pager = pager;
        break;
      }

      case NEWSLETTER_DETAILS_GET._SUCCESS: {
        draft.details = action.response;
        break;
      }

      case NEWSLETTER_DETAILS_RESET: {
        draft.details = initialState.details;
        draft.baseTemplate = initialState.baseTemplate;
        break;
      }

      case NEWSLETTER_BASE_TEMPLATE_GET._SUCCESS: {
        draft.baseTemplate = action.response?.newsletter_template || '';
        break;
      }

      case NEWSLETTER_SEND._SUCCESS: {
        draft.sentCounter = state.sentCounter + 1;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default newsletterReducer;
